import React from 'react';

interface StatusBadgeProps {
    status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const statusConfig: { [key: string]: { text: string; bgColor: string; textColor: string } } = {
        'PENDENTE': { text: 'Pendente', bgColor: 'rgba(255, 193, 7, 0.2)', textColor: '#FFC107' },
        'CONFIGURANDO': { text: 'Configurando', bgColor: 'rgba(33, 150, 243, 0.2)', textColor: '#2196F3' },
        'AGUARDANDO_ATIVACAO': { text: 'Aguardando Ativação', bgColor: 'rgba(255, 152, 0, 0.2)', textColor: '#FF9800' },
        'AGUARDANDO_PORTABILIDADE': { text: 'Aguardando Portabilidade', bgColor: 'rgba(156, 39, 176, 0.2)', textColor: '#9C27B0' },
        'ATIVO': { text: 'Ativo', bgColor: 'rgba(76, 175, 80, 0.2)', textColor: '#4CAF50' },
        'SUSPENSO': { text: 'Suspenso', bgColor: 'rgba(244, 67, 54, 0.2)', textColor: '#F44336' },
        'CANCELADO': { text: 'Cancelado', bgColor: 'rgba(158, 158, 158, 0.2)', textColor: '#9E9E9E' },
        'A': { text: 'Ativo', bgColor: 'rgba(76, 175, 80, 0.2)', textColor: '#4CAF50' },
        'P': { text: 'Pendente', bgColor: 'rgba(255, 193, 7, 0.2)', textColor: '#FFC107' },
        'S': { text: 'Suspenso', bgColor: 'rgba(244, 67, 54, 0.2)', textColor: '#F44336' },
        'C': { text: 'Cancelado', bgColor: 'rgba(158, 158, 158, 0.2)', textColor: '#9E9E9E' }
    };

    const config = statusConfig[status] || { text: status, bgColor: 'rgba(158, 158, 158, 0.2)', textColor: '#9E9E9E' };

    return (
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: '4px 10px',
            borderRadius: '999px',
            fontSize: '12px',
            fontWeight: 600,
            backgroundColor: config.bgColor,
            color: config.textColor
        }}>
            {config.text}
        </span>
    );
};

export default StatusBadge;
